export { default } from './ListSubheader';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/ListSubheader/index.js
// module id = 551
// module chunks = 2